export const SECRET = 'CQuDpTOZvM34EjLR1G0r570PwokqrsMh6fQmY8He'
